// Reserved field names that exist BOTH as Registration/Buyer top-level columns
// AND as custom-field entries (for admin form config). We must never duplicate
// these in admin tables / export pickers: the top-level column is the source
// of truth. Keeps SalesManagement.jsx and BuyersList.jsx in sync.
export const RESERVED_CORE_FIELD_NAMES = ["first_name", "last_name", "email", "phone", "church", "age"];
